import { render, staticRenderFns } from "./NoticeDetails.vue?vue&type=template&id=e707a552&scoped=true"
import script from "./NoticeDetails.vue?vue&type=script&lang=js"
export * from "./NoticeDetails.vue?vue&type=script&lang=js"
import style0 from "./NoticeDetails.vue?vue&type=style&index=0&id=e707a552&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e707a552",
  null
  
)

export default component.exports